module.exports = __webpack_public_path__ + "static/media/icon-copy.fa0d1c8f.svg";